import { createSlice } from "@reduxjs/toolkit";

const ticketSlice = createSlice({
    name: "ticket",
    initialState: {
        tickets: [],
        replies: []
    },
    reducers: {
        setTicket: (state, action) => {
            state.tickets = action.payload;
        },
        updateTicket: (state, action) => {
            state.tickets = state.tickets.map(item => item._id == action.payload._id ? action.payload : item);
        },
        deleteTicket: (state, action) => {
            state.tickets = state.tickets.filter(item => item._id != action.payload._id);
        },
        addTicketReplyState: (state, action) => {
            state.replies = [action.payload,...state.replies];
        },
        setTicketReplies: (state, action) => {
            state.replies = action.payload;
        },
    },
});

export const { setTicket, updateTicket, deleteTicket, addTicketReplyState,setTicketReplies } = ticketSlice.actions;

export default ticketSlice.reducer;
